module.exports = __webpack_public_path__ + "img/2.4ba4e52f.png";